export class StudentLifeCycle {
  isUserGuest = true;
  isUserRegistered = false;
  isUserDrivingTraining = false;
  isUserWaitingForBooking = false;
  isUserDrivingBooked = false;
  isUserDrivingSuccess = false;
  isFrozen = false;
  isUserEngaged = false;
  isUserCanBookExamCode = false;
  isUserHasCodeBooked = false;
  isUserCanDrive = false;
  isUserStartedDriving = false;
  isUserNeedCompleteRegistration = false;
  isUserNeedEnterNEPH = false;
}
